import React, { FC } from "react";
import PostCardCommentBtn from "componentsTemplate/PostCardCommentBtn/PostCardCommentBtn";
import PostCardLikeAction from "componentsTemplate/PostCardLikeAction/PostCardLikeAction";

export interface PostCardLikeAndCommentProps {
  className?: string;
  itemClass?: string;
  hiddenCommentOnMobile?: boolean;
  useOnSinglePage?: boolean;
  likeCount?: number;
  commentsCount?: number;
}

const PostCardLikeAndComment: FC<PostCardLikeAndCommentProps> = ({
  className = "",
  itemClass = "px-3 h-8 text-xs",
  hiddenCommentOnMobile = true,
  useOnSinglePage = false,
  likeCount = 0,
  commentsCount = 0,
}) => {
  return (
    <div
      className={`nc-PostCardLikeAndComment flex items-center space-x-2 ${className}`}
    >
      <PostCardLikeAction likeCount={likeCount} className={itemClass} />
      <PostCardCommentBtn
        className={`${
          hiddenCommentOnMobile ? "hidden sm:flex" : "flex"
        }  ${itemClass}`}
        isATagOnSingle={useOnSinglePage}
        commentsCount={commentsCount}
      />
    </div>
  );
};

export default PostCardLikeAndComment;
